import {GridDataEntry} from "controls/grid/gridDataEntry";
import {GridStore} from "controls/grid/gridStore";

export type GridStoreHolder<T extends GridDataEntry> = GridStore<T> | { gridStore: GridStore<T> }

export function getStore<T extends GridDataEntry>(holder: GridStoreHolder<T>) {
	if (holder == null)
		return null

	return 'gridStore' in holder ? holder.gridStore : holder
}
